// Used for analytics event context for secondary (floating button) view
export const BUTTON_ACTION_SUBJECT_ID = 'nuxOnboardingQuickstartButton';
